<script>
    import { onMount } from "svelte";
    import { store } from "../../store.js";
    import Section from "../Common/Section.svelte";
    import LinkButton2 from "../Common/LinkButton2.svelte";
    import Typewriter from "svelte-typewriter";
    import Countdown from '../Common/Countdown/Countdown.svelte';
    import sections from "./sections";

    let y;

    
</script>
<svelte:window bind:scrollY={y} />

<section style:position={"relative"}>

    <Section name="airdropAnchor" id="airdrop" styles={sections[$store.type][$store.locale]['airdropAnchor'] || null} />

    <Section
        name="nft1"
        styles={sections[$store.type][$store.locale]['nft1'] || null}
    >
        <div class="event-title1 text-white">
            1ST KONNECT NFT MINTING
        </div>
    </Section>

    <Section
        name="nft2"
        styles={sections[$store.type][$store.locale]['nft2'] || null}

    >
        <div class="event-desc text-white">
            Konnect World's first NFT is the Profile Picture (PFP) of the first five DUMANs to arrive on Earth.
            DUMAN NFT provides real benefits with its partners on Earth.
        </div>
    </Section>

    <!-- <Section
        name="nft2-2"
        styles={sections[$store.type][$store.locale]['nft2-2'] || null}

    >
        {#if $store.locale === 'en'}
            <div class="event-title1">
                Time Remaining
            </div>     
        {:else if $store.locale === 'kr'}
            <div class="event-title1">
                남은 시간
            </div>
        {:else if $store.locale === 'vn'}
            <div class="event-title1">
                Time Remaining
            </div>
        {/if} 
    </Section> -->

    <Section
        name="nft3"
        styles={sections[$store.type][$store.locale]['nft3'] || null}

    >
        <!-- <Countdown from="2022-08-31 19:00:00" format="YYYY-MM-DD H:m:s" zone="Asia/Seoul" let:remaining>
            <div class="whatever">                
                <span>
                    {`${(remaining.years * 8766) + (remaining.weeks * 168) + (remaining.days * 24) + remaining.hours}`.padStart(2, '0')}:
                </span>
                <span>{`${remaining.minutes}`.padStart(2, '0')}:</span>
                <span>{`${remaining.seconds}`.padStart(2, '0')}</span>

            </div>
        </Countdown> -->
        {#if $store.locale === 'en' || $store.locale === 'vn'}
        <div class="event-desc text-center">
            The first Konnect PFP NFT minting has successfully ended!
            The new species will be introduced in 2023 so
            Keep yourselves updated at all time :)
        </div> 
        {:else}
        <div class="event-desc text-center">
           커넥트 첫 PFP 민팅을 성공적으로 완료했습니다!
           2023년 새로운 종족이 여러분을 찾아가니
           항상 귀기울여 주세요 :)
        </div> 
        {/if}

    </Section>

    <Section
        name="nft4"
        styles={sections[$store.type][$store.locale]['nft4'] || null}

    >
        {#if $store.locale === 'en'}
            <div class="event-desc text-center">
                Minting Time : TBA
                Quantity : TBA
                Price : TBA
                <!-- <span style="color:#55A2FF">* 10% discount if paid in KCT</span> -->
            </div>     
        {:else if $store.locale === 'kr'}
            <div class="event-desc text-center">
                민팅 시간 : TBA 
                수량 : TBA
                가격 : TBA
                <!-- <span style="color:#55A2FF">* KCT로 구매시 10% 할인</span> -->
            </div>
        {:else if $store.locale === 'vn'}
            <div class="event-desc text-center">
                Minting Time : TBA
                Quantity : TBA
                Price : TBA
                <!-- <span style="color:#55A2FF">* 10% discount if paid in KCT</span> -->
            </div>
        {/if}  
    </Section>

    <!-- <Section
        name="nft5"
        styles={sections[$store.type][$store.locale]['nft5'] || null}

    >
        <LinkButton2
            styles={$store.locale === "en"
                ? { width: 550, height: 100 }
                : $store.locale === "kr"
                ? { width: 550, height: 100 }
                : $store.locale === "vn"
                ? { width: 550, height: 100 }
                : null}
            hide={false}
            cursor={true}
            typewriter={false}
            logo={true}
            onClick={()=>alert($store.locale === 'en' ? "Event has ended" : $store.locale === 'kr' ? "이벤트가 종료되었습니다": "Event has ended")}
            text={
                $store.locale === 'en' ? "Apply for NFT Event" 
                : $store.locale === 'kr' ? "NFT 이벤트 참여하기"
                : $store.locale === 'vn' ? "Tham gia sự kiện NFT" : "Apply for NFT Event"
            }
        /> 
    </Section>-->

    <Section name="aboutAnchor" id="about" styles={sections[$store.type][$store.locale]['aboutAnchor'] || null} />

    <!-- <Section
        name="nft6"
        styles={sections[$store.type][$store.locale]['nft6'] || null}

    >
        <LinkButton2
            styles={$store.locale === "en"
                ? { width: 550, height: 100 }
                : $store.locale === "kr"
                ? { width: 550, height: 100 }
                : $store.locale === "vn"
                ? { width: 550, height: 100 }
                : null}
            hide={false}
            cursor={true}
            typewriter={false}
            logo={true}
            onClick={()=>{
                if($store.locale === 'en') {
                    alert('Getting ready!')
                } else if($store.locale === 'kr') {
                    location.href = 'https://blog.naver.com/konnect_finance/222726626782';
                } else {
                    alert('Getting ready!')
                }
            }}
            text={
                $store.locale === 'en' ? "Check the Whitelist" 
                : $store.locale === 'kr' ? "화이트리스트 보기"
                : $store.locale === 'vn' ? "Xem whitelist" :  "Check the Whitelist"
            }
        />
    </Section> -->

    <Section
        name="nft7"
        styles={sections[$store.type][$store.locale]['nft7'] || null}
    >
        <Typewriter cascade loop={true} interval={100} cursor={false}>
            {#if $store.locale === 'en'}
            <h1 class="question font-koho">Do you own any NFTs?</h1>
            {:else if $store.locale === 'kr'}
            <h1 class="question font-koho">너는 어떤 NFT 가지고 있니?</h1>
            {:else if $store.locale === 'vn'}
            <h1 class="question font-koho">Bạn đã có Konnect NFT chưa?</h1>
            {:else}
            <h1 class="question font-koho">Do you own any NFTs?</h1>
            {/if}            
        </Typewriter>
    </Section>

    <Section
        name="nft8"
        styles={sections[$store.type][$store.locale]['nft8'] || null}
    >
        {#if $store.locale === 'en'}
            <div class="section-desc">
                In the near future, people will start asking this question as if it were a greeting.
                A world where more people own and want to own NFTs is happening rapidly.
                Meet Konnect NFTs that help secure your individual rights and ownership through DLT technology.
                Konnect NFTs can be purchased with cryptocurrencies and KCT.
            </div>
        {:else if $store.locale === 'kr'}
            <div class="section-desc">
                인사처럼 물어볼 이 질문이 이제 곧 다가올 우리의 모습입니다.
                점점 더 많은 사람들이 NFT를 소유하고 원하는 세상이
                우리 생각보다 더 빠르게 곁으로 다가왔습니다.
                탈중앙화를 통해 개인의 권리가 더 보장받는 세계에서 Konnect가 연결하는 NFT를 만나보세요.
                Konnect의 NFT는 KCT 토큰을 통해 구매할 수 있습니다.
            </div>
        {:else if $store.locale === 'vn'}
            <div class="section-desc text-center">
                Khi hệ sinh thái Konnect được hình thành thì đây 
                chính là lời chào mà chúng ta sẽ nhận được trong 
                kỷ nguyên tới. Giá trị của NFT càng tăng lên, 
                càng có nhiều người muốn sở hữu NFT hơn, và 
                viễn  cảnh về một thế giới nơi những chủ sở 
                hữu NFT là những người đáng ghen tị sẽ đến sớm hơn chúng 
                ta nghĩ. Konnect kết nối chúng ta với NFT thông 
                qua KCT token, một loại tiền mã hóa có thể đảm bảo 
                quyền lợi cá nhân chặt chẽ hơn thông qua phân quyền
                (decentralization).
            </div>
        {:else}
            <div class="section-desc">
                In the near future, people will start asking this question as if it were a greeting.
                A world where more people own and want to own NFTs is happening rapidly.
                Meet Konnect NFTs that help secure your individual rights and ownership through DLT technology.
                Konnect NFTs can be purchased with cryptocurrencies and KCT.
            </div>
        {/if} 

    </Section>

    <Section name="nftAnchor" id="nft" styles={sections[$store.type][$store.locale]['nftAnchor'] || null} />

    <Section
        name="nft9"
        styles={sections[$store.type][$store.locale]['nft9'] || null}
    >
        <Typewriter cascade loop={true} interval={100} cursor={false}>
            <h1 class="question font-koho">KONNECT NFT MARKETPLACE</h1>            
        </Typewriter>
    </Section>

    <Section
        name="nft10"
        styles={sections[$store.type][$store.locale]['nft10'] || null}
    >
        {#if $store.locale === 'en'}
            <div class="question-desc">
                You can obtain NFTs minted from the Konnect World via Konnect NFT Marketplace. Konnect NFTs are scheduled to be
                released in April. Unlike other NFTs that exist and are only present virtually, Konnect NFTs are connected
                with real-world assets and economy.
            </div> 
        {:else if $store.locale === 'kr'}
            <div class="question-desc">
                Konnect NFT Marketplace를 통해 Konnect World에서 민팅된 NFT를 획득할 수 있습니다.
                Konnect NFT는 4월 중 출시예정으로, 가상 세계에서만 존재하는 여타 NFT와는 다르게 실물 경제의 혜택이 존재합니다.
            </div>
        {:else if $store.locale === 'vn'}
            <div class="question-desc">
                Bạn có thể sở hữu NFT được minting trong Konnect World thông qua Konnect NFT Market Place.
                Konnect NFT dự kiến ​​sẽ được phát hành vào tháng 4, và không giống như các NFT khác chỉ tồn tại trong thế giới ảo, 
                Konnect NFT sẽ có những lợi ích kinh tế thực sự.
            </div>
        {/if}
    </Section>

    <Section
        name="nft11"
        styles={sections[$store.type][$store.locale]['nft11'] || null}
    >
        <LinkButton2
            styles={$store.locale === "en"
                ? { width: 550, height: 100 }
                : $store.locale === "kr"
                ? { width: 550, height: 100 }
                : $store.locale === "vn"
                ? { width: 550, height: 100 }
                : null}
            hide={false}
            cursor={true}
            typewriter={false}
            logo={true}
            onClick={()=>alert('Coming Soon!')}
            text={
                $store.locale === 'en' ? "Released Soon!" 
                : $store.locale === 'kr' ? "런칭 예정!"
                : $store.locale === 'vn' ? "Phát hành sớm!" : "Released Soon!"
            }
        />
    </Section>

    <Section
        name="nft12"
        styles={sections[$store.type][$store.locale]['nft12'] || null}
    >
        <div class="list-title">
            # Mystery Box
        </div>        
    </Section>

    <Section
        name="nft13"
        styles={sections[$store.type][$store.locale]['nft13'] || null}
    >
        {#if $store.locale === 'en'}
            <div class="list-item">
                The Mystery Box is a gift from the Konnect World. Each box is classified by their level and a corresponding high-end brand
                product is randomly assigned. Users can choose to claim the physical asset tied to the NFT.
            </div>
        {:else if $store.locale === 'kr'}
            <div class="list-item">
                미스터리 박스는 Konnect World에서 가져온 선물입니다. 각 상자에는 등급에 맞는 명품 브랜드 제품이 랜덤으로 들어있으며, 실제 현물 제품도 함께 제공됩니다.
            </div>
        {:else if $store.locale === 'vn'}
            <div class="list-item">
                DUMAN đã mang đến Mystery Box như một món quà từ Konnect World. Mystery Box có những cấp bậc khác nhau, chứa các sản phẩm hàng hiệu phù hợp với từng cấp bậc. Những sản phẩm này không chỉ tồn tại trong metaverse, chúng có thể được đổi thành sản phẩm thật trong thế giới thật.
            </div>
        {/if}
    </Section>

    <Section
        name="nft14"
        styles={sections[$store.type][$store.locale]['nft14'] || null}
    >
        <div class="list-title">
            # DUMAN
        </div>
    </Section>

    <Section
        name="nft15"
        styles={sections[$store.type][$store.locale]['nft15'] || null}
    >
        {#if $store.locale === 'en'}
            <div class="list-item">
                DUMAN, the dominant species of the Konnect World, has advanced intelligence through the influence of Konnect.
                They share the same culture with humans and have similar characteristics.
            </div>
        {:else if $store.locale === 'kr'}
            <div class="list-item">
                Konnect World의 지배종인 DUMAN은 Konnect의 영향으로 지능이 향상되었습니다.
                그들은 인간과 같은 문화를 공유하고 비슷한 취향을 가지고 있습니다.
            </div>
        {:else if $store.locale === 'vn'}
            <div class="list-item">
                DUMAN, người cai trị Konnect World, đã hấp thụ năng lượng Konnect và đạt được trí thông minh siêu việt. 
                Nhờ chia sẻ và tận hưởng nền văn hóa giống như con người nên họ cũng có những khuynh hướng, sở thích tương tự con người.
            </div>
        {/if}
    </Section>

    <Section name="storyAnchor" id="story" styles={sections[$store.type][$store.locale]['storyAnchor'] || null} />
    
    <Section
        name="nft16"
        styles={sections[$store.type][$store.locale]['nft16'] || null}
    >
        <div class="section-title text-white">
            KONNECT STORY
        </div>
    </Section>

    <Section
        name="nft17"
        styles={sections[$store.type][$store.locale]['nft17'] || null}
    >
        {#if $store.locale === 'en'}
            <div class="list-item text-white">
                Konnect Story embodies and unfolds the story of the Konnect World. Dive further into the story of the 'Konnect World' and see how
                two Earths in parallel universes are bridging the virtual and physical world.
            </div>
        {:else if $store.locale === 'kr'}
            <div class="list-item text-white">
                Konnect Story는 Konnect World 세계관의 이야기이며 이를 바탕으로 메타버스까지 목표합니다.
                평행 우주에 존재하는 두 개의 지구가 만들어내는 가상과 현실을 그려낸 Konnect Story를 만나보세요 :)
            </div>
        {:else if $store.locale === 'vn'}
            <div class="list-item text-white">
                Câu chuyện Konnect là câu chuyện của vũ trụ Konnect World, và dựa trên câu chuyện này, chúng tôi sẽ thực hiện nó trong metaverse.
                Gặp gỡ câu chuyện Konnect mô tả thực và ảo được tạo ra bởi hai trái đất trong một vũ trụ song song :)
            </div>
        {/if}
    </Section>

    <Section
        name="nft18"
        styles={sections[$store.type][$store.locale]['nft18'] || null}
    >
        <div class="story-title text-white">
            # 01. Konnect World
        </div>
    </Section>
    
    <Section
        name="nft19"
        styles={sections[$store.type][$store.locale]['nft19'] || null}
    >
        {#if $store.locale === 'en'}
            <div class="story-desc text-white">
                There are multiple Earths seperated by different dimensions and parallel universes. Among them, Konnect is ruled by the Duman species that has managed to create a civilization far more advanced than the earth we know today.
            </div>
        {:else if $store.locale === 'kr'}
            <div class="story-desc text-white">
                평행우주 속에서 존재하는 수 많은 지구, 그 중 하나인 Konnect에는 우리의 지구보다 더 고도화된 문명을 이룩한 DUMAN 종족이 살고있다. 그들은 빅뱅 에너지가 응축된 Konnect라는 물질을 가공하여 무한대의 에너지를 만들어내는 기술을 가지고 있었다.
            </div>
        {:else if $store.locale === 'vn'}
            <div class="story-desc text-white">
                Konnect, một trong vô số trái đất trong vũ trụ song song, là nơi sinh sống của DUMAN người đã tạo ra một nền văn minh tiên tiến hơn chúng ta rất nhiều. Họ sử dụng một loại vật chất gọi là Konnect chứa năng lượng lớn và đang sở hữu công nghệ có thể sử dụng năng lượng vô tận.
            </div>
        {/if}
    </Section>

    <Section
        name="nft20"
        styles={sections[$store.type][$store.locale]['nft20'] || null}
    >
        {#if $store.locale === 'en'}
            <div class="story-title text-white">
                # 02. Birth of Konnect
            </div>
        {:else if $store.locale === 'kr'}
            <div class="story-title text-white">
                # 02. Konnect의 탄생
            </div>
        {:else if $store.locale === 'vn'}
            <div class="story-title text-white">
                # 02. Sự ra đời của Connect
            </div>
        {/if}
    </Section>

    <Section
        name="nft21"
        styles={sections[$store.type][$store.locale]['nft21'] || null}
    >
        {#if $store.locale === 'en'}
            <div class="story-desc text-white">
                In 1883, meteors made of Konnect fell to the earth. Since the impace, the two earth which had Konnect and not in parallel universe after that, the one with metoer start to experience significant environment change due to Konnect's bigbang energy
            </div>
        {:else if $store.locale === 'kr'}
            <div class="story-desc text-white">
                1883년 지구에 Konnect로 이루어진 운석이 떨어진다. 평행주우에선 이 충돌을 기점으로 Konnect 운석이 떨어진 지구와 그렇지 않은 지구, 둘로 나뉘게 된다. 이후 운석이 떨어진 지구에서는 빅뱅에너지를 지닌 Konnect의 영향으로 급격한 환경의 변화가 시작되었다.
            </div>
        {:else if $store.locale === 'vn'}
            <div class="story-desc text-white">
                Năm 1883, một thiên thạch hình thành từ Konnect đã rơi xuống Trái đất. Trong vũ trụ song song, sau vụ va chạm thiên thạch trái đất bị chia thành hai phần, lục địa bị ảnh hưởng bởi thiên thạch Konnect và những lục địa không bị ảnh hưởng. Kể từ đó, lục địa nơi có thiên thạch rơi xuống bắt đầu có những thay đổi trong môi trường nhanh chóng dưới ảnh hưởng của Konnect chứa nguồn năng lượng dồi dào.
            </div>
        {/if}
    </Section>

    <Section
        name="nft22"
        styles={sections[$store.type][$store.locale]['nft22'] || null}
    >
        {#if $store.locale === 'en'}
            <div class="story-title text-white">
                # 03. DUMAN Evolution
            </div>
        {:else if $store.locale === 'kr'}
            <div class="story-title text-white">
                # 03. DUMAN의 진화
            </div>
        {:else if $store.locale === 'vn'}
            <div class="story-title text-white">
                # 03. Sự tiến hóa của DUMAN
            </div>
        {/if}
    </Section>

    <Section
        name="nft23"
        styles={sections[$store.type][$store.locale]['nft23'] || null}
    >
        {#if $store.locale === 'en'}
            <div class="story-desc text-white">
                The Earth, which absorbed Konnect energy, started to emit more powerful nature energy. It affected in good way to the nature and animals, but not humans.
                The Konnect energy radiant earth is no longer fit for humans to live so that humans extincted from the earth with less than a year.
                And a new race, DUMAN, came to rule the Earth.
            </div>
        {:else if $store.locale === 'kr'}
            <div class="story-desc text-white">
                Konnect 에너지를 빠르게 흡수한 지구는 더욱 강력한 자연에너지를 뿜게 되었다. 이 네어지는 자연과 동물에게는 좋은 영향이었으나 인간에게는 그렇지 않았다. Konnect 에너지를 방출하기 시작한 지구는 더 이상 인간이 감당할 수 없게되고 1년이 채 안되는 시간동인 인류는 지구에서 사라지게 된다. 이후 새로운 종족이 DUMAN이 지구를 지배하게 된다.
            </div>
        {:else if $store.locale === 'vn'}
            <div class="story-desc text-white">
                Trái đất sau khi nhanh chóng hấp thụ năng lượng Konnect, đã càng tỏa ra năng lượng tự nhiên mạnh mẽ hơn. Nguồn năng lượng này lành mạnh đối với thiên nhiên và động vật, nhưng lại không tốt cho con người. Sau khi trái đất bắt đầu giải phóng năng lượng Konnect, con người sẽ không thể chịu đựng được nữa, và trong vòng chưa đầy 1 năm, loài người sẽ biết mất khỏi trái đất. Và rồi sau đó, một chủng tộc mới tên là DUMAN sẽ thống trị trái đất.
            </div>
        {/if}
    </Section>

    <Section
        name="nft24"
        styles={sections[$store.type][$store.locale]['nft24'] || null}
    >
        {#if $store.locale === 'en'}
            <div class="story-title text-white">
                # 04. The Appearance of Mystery Boxes
            </div>
        {:else if $store.locale === 'kr'}
            <div class="story-title text-white">
                # 04. 미스테리 박스의 출현
            </div>
        {:else if $store.locale === 'vn'}
            <div class="story-title text-white">
                # 04. Sự xuất hiện của những chiếc hộp bí ẩn
            </div>
        {/if}
    </Section>

    <Section
        name="nft25"
        styles={sections[$store.type][$store.locale]['nft25'] || null}
    >
        {#if $store.locale === 'en'}
            <div class="story-desc text-white">
                On the Earth in 2022, an unknown phenomenon suddenly
                occurs in the sky. A giant dark hole appeared.
                People panicked and were frightened for what may come
                from the hole.
                The world governments weren't ready to respond.
                Some time after, box-shaped stuff began
                to fall from the hole. People just stared at them
                while numerous boxes started to float around.
            </div>
        {:else if $store.locale === 'kr'}
            <div class="story-desc text-white">
                2022년 지구, 하늘에서 갑자기 알 수 없는 현상이 일어난다.
                지구 곳곳에서 하늘에 구멍이라도 난듯이 무엇인가 나타났다.
                사람들은 처음보는 현상에 놀라움과 두려움을 느겼고,
                정부 또한 어떻게 대응할지 모르는 상태였다. 그때, 하늘에
                생긴 구멍에서 박스형태의 무엇들이 떨어지기 시작했다.
                수많은 박스들이 날아오는 광경을 사람들은 넋놓고
                바라보고만 있었다.
            </div>
        {:else if $store.locale === 'vn'}
            <div class="story-desc text-white">
                Năm 2022 ở Trái Đất, trên bầu trời đột nhiên xảy ra một hiện tượng không xác định được. Ở nhiều nơi trên Trái Đất, có thứ gì đó trông giống như một cái lỗ xuất hiện trên bầu trời. Con người bất ngờ và sợ hãi khi lần đầu nhìn thấy hiện tượng này, và chính phủ cũng không biết phải ứng phó thế nào. Vào lúc đó, từ cái lỗ trên bầu trời, những chiếc hộp bắt đầu rơi xuống. Con người đứng thẫn thờ nhìn cảnh tượng vô số những chiếc hộp bay khắp nơi.

            </div>
        {/if}
    </Section>
    <Section
        name="nft26"
        styles={sections[$store.type][$store.locale]['nft26'] || null}
    >
        <LinkButton2
            styles={$store.locale === "en"
                ? { width: 500, height: 100 }
                : $store.locale === "kr"
                ? { width: 500, height: 100 }
                : $store.locale === "vn"
                ? { width: 500, height: 100 }
                : null}
            hide={false}
            onClick={()=>location.href="https://konnect-world.com/Story"}
            cursor={true}
            typewriter={false}
            logo={true}
            text={
                $store.locale === 'en' ? "Check First Story" 
                : $store.locale === 'kr' ? "첫 스토리보러 가기"
                : $store.locale === 'vn' ? "Kiểm tra câu chuyện đầu tiên" : "Check First Story"
            }
        />
    </Section>

</section>

<style>
    .question {
        font-size: 6vw;
        font-weight: 500;
        letter-spacing: -1px;
    }

    .event-title1 {
        font-size: 4.5vw;
        font-family: koho;
    }

    .event-title2 {
        font-family: koho;
        font-size: 8vw;
        font-weight: 500;
    }

    .event-desc {
        font-size: 3vw;
        white-space: pre-line;
        font-weight: 300;
    }

    .section-title {
        font-size: 6vw;
        font-weight: 600;
    }

    .section-subtitle {
        font-size: 2vw;
        font-weight: 600;
    }

    .story-title {
        font-size: 5vw;
        font-weight: 600;
        letter-spacing: -1px;
    }

    .story-desc {
        font-size: 4vw;
        line-height: 6.5vw;
        font-weight: 200;
    }

    .section-desc {
        font-size: 4vw;
        /* white-space: pre-line; */
        line-height: 6.5vw;
    }

    .question-desc {
        font-size: 4vw;
        line-height: 6.5vw;
    }

    .list-title {
        font-size: 5vw;
        font-weight: 600;
    }

    .list-item {
        font-size: 4vw;
        white-space: pre-line;
        line-height: 6.5vw;
    }

    .whatever {
        font-family: "digital-7";
        font-size: 9vw;
    }

    .menu {
        display: inline-block;
        position: fixed;
        left: 0;
        width: 350px;
        top: 60px;
        height: 500px;
    }

    .menu ul {
        list-style-type: none;
        padding-left: 87px;
        margin-top: 65px;
    }

    .menu ul::before{
        content: '';
        display: block;
        width: 50%;
        border: 1px solid black;
        margin-bottom: 20px;
    }

    .menu ul li {
        font-size: 1.2vw;
        margin-bottom: 10px;
        letter-spacing: -1px;
    }

    .menu ul li a {
        color: inherit;
        text-decoration: inherit;
    }

    :global(.menu ul li a.active) {
        font-weight: bold;
    }

    .menu ul li a:active, .menu ul li a:focus {
        /* font-weight: bold; */
        outline: none;
        box-shadow: none;
    }

</style>
